import type { LocationStore } from '@fitness-force/models';
import { loadPayengine } from 'payengine';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanySignUpService {
  private http = inject(HttpClient);

  _id: string ;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  constructor() {
    if (localStorage.getItem("COMPANY_SIGNUP_ID")){
      this._id = localStorage.getItem("COMPANY_SIGNUP_ID")?String(localStorage.getItem("COMPANY_SIGNUP_ID")):'';
    }

  }

  set Id(value: string) {

    this._id = value;
    localStorage.setItem("COMPANY_SIGNUP_ID", value?value:'' );
  }

  get Id():string {
    return this._id
  }







  createCompanySession(
    data: any
  ) {
    return this.http
      .post(
        `${environment.BASE_URL}/open/ncs/external_login`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  createInitiateSignup(
    data: any
  ) {
    return this.http
      .post(
        `${environment.BASE_URL}/open/ncs/initiate_signup`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createNewBusiness(
    UUID: string, data: any
  ) {
    return this.http
      .post(
        `${environment.BASE_URL}/ncs/${UUID}/create_new_business`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}

